<template>
  <v-list
    id="dashboard-menu"
    class="sidebar-menu is-active animated preFadeInRIght fadeInRight"
  >
    <MainMenuEntry
      v-for="entry in menuEntries"
      :key="entry.location.name"
      :icon-name="entry.iconName"
      :text="entry.text"
      :location="entry.location"
    />
  </v-list>
</template>

<script setup lang="ts">
import { brelagAdminRouteName } from '@/apps/brelag/brelag-admin/app'
import MainMenuEntry from '@/components/navigation/MainMenuEntry.vue'
import { i18n } from '@/lang/setup'
const menuEntries = [
  {
    iconName: 'mdi-account-group',
    text: i18n.global.t('apps.brelag.mandator', 2),
    location: { name: brelagAdminRouteName('mandator-root') },
  },
  {
    iconName: 'mdi-account-supervisor',
    text: i18n.global.t('apps.brelag.supporter', 2),
    location: { name: brelagAdminRouteName('supporter-root') },
  },
  {
    iconName: 'mdi-account-star',
    text: i18n.global.t('apps.brelag.admin', 2),
    location: { name: brelagAdminRouteName('admin-root') },
  },
  {
    iconName: 'mdi-account',
    text: i18n.global.t('apps.brelag.user', 2),
    location: { name: brelagAdminRouteName('user-root') },
  },
  {
    iconName: 'mdi-cash',
    text: i18n.global.t('apps.brelag.offer', 2),
    location: { name: brelagAdminRouteName('offer-root') },
  },
  {
    iconName: 'mdi-view-module',
    text: i18n.global.t('apps.brelag.knockautModule', 2),
    location: { name: brelagAdminRouteName('knockaut-module-root') },
  },
]
</script>
